
import { PurchasingAgreementService } from './purchase-agreement/PurchasingAgreementService.js';
import { setDropdown } from './form-controls.js'
import DeliveryAssuranceModule from './delivery-assurance.js';

$(function () {
    PriceAlertPage.init();
    DryingAgreement.init();
    GrainPricePage.init();
});

var PriceAlertPage = PriceAlertPage || (function () {

    var deletePriceAlert = function (priceWatch, id) {
        var parameters = "{'id':'" + id + "'}";
        $.ajax({
            type: 'POST',
            url: '/api/price-alert/DeletePriceWatch',
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: parameters,
            success: function (response) {
                if (response.isRemoved) {
                    $(priceWatch).remove();
                }
                else {
                    alert("Error");
                }
            },
            error: function (response) { }
        });
    };

    var deletePriceAlertEvent = function () {
        $(".priceAlertDelete").on("click", function (e) {
            var $item = $(this);
            DeliveryAssuranceModule.confirmDialog(function () {
                var id = $item.attr("data-value");
                var itemPriceWatch = $item.parents("tr");
                deletePriceAlert(itemPriceWatch, id);
            },
                function () {

                });

            e.preventDefault();
        });
    };

    var initEvent = function () {
        deletePriceAlertEvent();
    };

    var init = function () {
        initEvent();
    };

    return {
        init: init
    };
})();

var GrainPricePage = GrainPricePage || (function () {
    var isLegacyPage = function () {
        var path = window.location.pathname || '';
        if (path.toLowerCase().includes('/2025-spannmalspriser/')) {
            return true;
        }
        return $("#legacy-price-period-result").length > 0 || $("#legacy-btnShowGrainPrices").length > 0;
    };

    var getPricePeriods = function (area, itemNumber, sort, date) {
        var tableResult = $("#price-period-result");
        $("#loader").show();
        var pageId = $("#page-id").data("page-id");

        var priceSearch = {
            Area: area,
            ItemNumber: itemNumber,
            Sort: sort,
            Date: date,
            PageId: pageId
        };
        $.ajax({
            type: 'POST',
            url: '/api/price-grain/GetPricePeriods',
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(priceSearch),
            success: function (response) {
                if (!response) {
                    tableResult.html("<div>Det finns inga aktuella priser för valt område och gröda/sort.</div>");
                } else {
                    tableResult.html(response);
                }
            },
            error: function () {
                tableResult.html("<div>Det finns inga aktuella priser för valt område och gröda/sort.</div>");
            },
            complete: function (jqXHR) {
                $("#loader").hide();
            }
        });
    };

    var getFavorites = function () {
        var favoriteSearch = {
            Date: $("#price-grain-history").val(),
            PageId: $("#page-id").data("page-id")
        };
        var tableResult = $("#grain-price-favorites");
        $("#loader").show();
        $.ajax({
            type: 'POST',
            url: '/api/price-grain/get-favorites',
            data: JSON.stringify(favoriteSearch),
            contentType: "application/json; charset=utf-8",
            success: function (response) {
                if (response?.Data) {
                    tableResult.html(response?.Data);
                } else {
                    tableResult.html("<div>Det finns inga favoriter för valt område och gröda/sort.</div>");
                }
            },
            error: function () {
                tableResult.html("<div>Det finns inga favoriter för valt område och gröda/sort.</div>");
            },
            complete: function (jqXHR) {
                $("#loader").hide();
            }
        });
    };

    var updateFavorite = function (crop, addNew, favoriteSearch) {
        var tableResult = $("#grain-price-favorites");
        $("#loader").show();
        $.ajax({
            type: 'POST',
            url: '/api/price-grain/update-favorite',
            data: JSON.stringify({ crop: crop, addNew: addNew, favoriteSearch: favoriteSearch }),
            contentType: "application/json; charset=utf-8",
            success: function (response) {
                if (response?.Data) {
                    if ($("#price-period-result").length > 0 && $('.js-grain-price-favorite').data('itemnumber') == crop.ItemNumber) {
                        if (addNew) {
                            if (!$(".js-grain-price-favorite").hasClass("active"))
                                $(".js-grain-price-favorite").addClass("active");
                        } else if ($(".js-grain-price-favorite").hasClass("active")) {
                            $(".js-grain-price-favorite").removeClass("active");
                        }
                    }
                    tableResult.html(response?.Data);
                }
            },
            error: function () {
                if (addNew) {
                    alert("Något gick fel vid tilläggning av favorit.");
                } else {
                    alert("Något gick fel vid uppdatering av favorit.");
                }
            },
            complete: function (jqXHR) {
                $("#loader").hide();
            }
        });
    };

    var getGrainTypesForProduct = function (itemnumber) {
        $('#agreement-loader').show();
        $.ajax({
            dataType: "json",
            type: 'get',
            url: '/api/price-grain/get-grain-type-by-product',
            data: { itemnumber: itemnumber },
            cache: false,
            success: function (data) {
                $('#grain-type-list .dropdown').html('');
                if (data.Data.length > 0) {
                    data.Data.forEach((item, index) => {
                        if (index === 0) {
                            $('#grain-type-list').attr('data-value', "");
                            $('#grain-type-list > a').html("Välj sort");
                        }
                        $('#grain-type-list .dropdown').append(`<li data-value="${item.Name}"><a href="javascript:void(0)">${item.NameDescription}</a></li>`);
                    });

                    setDropdown($('.grain-Type-Dropdown'), 'type-3');
                    sortClickEvent();
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
            },
            complete: function (jqXHR) {
                $('#agreement-loader').hide();
            }
        });
    };

    var updateFavoriteClickEvent = function () {
        $(document).on("click",
            ".js-grain-price-favorite",
            function (e) {
                e.stopPropagation();

                var crop = {
                    ItemNumber: $(this).data("itemnumber"),
                    PriceArea: $(this).data("pricearea"),
                    Sort: $(this).data("sort"),
                    SortName: $(this).data("sortname"),
                };

                var favoriteSearch = {
                    Date: $("#price-grain-history").val(),
                    PageId: $("#page-id").data("page-id")
                };

                if ($(this).hasClass("active")) {
                    updateFavorite(crop, false, favoriteSearch);
                    $(this).toggleClass("active");
                } else {
                    var count = $("#favorites-count").val();
                    var maxFavorites = $("#max-favorites").html();
                    if (parseInt(count) < parseInt(maxFavorites)) {
                        updateFavorite(crop, true, favoriteSearch);
                        $(this).toggleClass("active");
                    } else {
                        $("#max-favorites-modal").show();
                    }
                }

            });
    };

    var showGrainPriceClickEvent = function () {
        $("#btnShowGrainPrices").on("click", function () {
            var priceAreaId = $('#price-area-list').attr('data-value');
            var itemNumber = $('#product-list').attr('data-value');
            var sort = $('#grain-type-list').attr('data-value');
            var date = $("#price-grain-history").val();
            getPricePeriods(priceAreaId, itemNumber, sort, date);
            if (!isLegacyPage()) {
                getFavorites();
            }
        });
    };

    var getSortByProductEvent = function () {
        var dropdownProducts = $('#product-list .dropdown li a');
        dropdownProducts.on("click", function (e) {
            var itemnumber = $(this).parent().attr('data-value');
            $("#btnShowGrainPrices").attr('disabled', true);
            $("#btnShowGrainPrices").removeClass("reverse-state");
            getGrainTypesForProduct(itemnumber);
        });
    };

    var sortClickEvent = function () {
        var dropdownSorts = $('#grain-type-list .dropdown li a');
        dropdownSorts.on("click", function (e) {
            $("#btnShowGrainPrices").attr('disabled', false);
            $("#btnShowGrainPrices").addClass("reverse-state");
        });
    };

    var initEvent = function () {
        showGrainPriceClickEvent();
        getSortByProductEvent();
        sortClickEvent();
        if (!isLegacyPage()) {
            getFavorites();
            updateFavoriteClickEvent();
        }
    };

    var init = function () {
        if ($("#price-period-result").length > 0) {
            initEvent();
        }

    };

    return {
        init: init
    };
})();

/**
 * @description Mask personal number
 * @param {*} personalNumber
 * @returns
 */
const maskPersonalNumber = (personalNumber) => {
    return typeof personalNumber === "string"
            ? personalNumber.replace(/\d(?=(?:\D*\d){0,3}$)/g, "*")
            : personalNumber;
}

var DryingAgreement = DryingAgreement || (function () {
    var $dryingAgreementForm = $("#dryingAgreementForm");
    var $sendForDigitalSigningForm = $("#SendForDigitalSigningForm");
    var isInternal = Number.parseInt($('#IsInternal').val()) === 1;
    var purchasingAgreementService = new PurchasingAgreementService();
    var $dropdownReceivers = $dryingAgreementForm.find('.receiverDropdown');
    function isOtherReceiver() {
        return $('#ReceiverName').val() == 'Annan behörig mottagare';
    }
    function onReceiverChange(event, selectedItem) {
        $('.div-text-other-receiver-info').addClass('hidden');
        var $dropdownItem = $dryingAgreementForm.find('.receiverDropdown .dropdown .selected');
        $dryingAgreementForm.find('#Signer').val($dropdownItem.data('email'));
        $dryingAgreementForm.find('#ReceiverName').val($dropdownItem.data('name'));
        $dryingAgreementForm.find('#ReceiverEmail').val($dropdownItem.data('email'));
        $dryingAgreementForm.find('#Mobilephone').val($dropdownItem.data('mobilephonenumber'));
        $dryingAgreementForm.find('#ReceiverPersonalNumber').val($dropdownItem.data('personalnumber'));

        /**
		 * Hide or show personal number input field
		 * Depends on selected receiver
		 */
		var parentDiv = $dryingAgreementForm.find("#ReceiverPersonalNumber").parent(".agreement-element");

        if (
            $dropdownItem.data("personalnumber") === null ||
            $dropdownItem.data("personalnumber") === ""
        ) {
            parentDiv.find("#ReceiverPersonalNumber").attr("type", "text");
            parentDiv.removeClass("hidden");
        } else {
			parentDiv.find("#ReceiverPersonalNumber").attr("type", "hidden");
            parentDiv.addClass("hidden");
		}

        $('#ReceiverName').parents('.agreement-element').removeClass('disabled');
        $('#ReceiverEmail').parents('.agreement-element').removeClass('disabled');
        $('#ReceiverPersonalNumber').parents('.agreement-element').removeClass('disabled');
        $('#Mobilephone').parents('.agreement-element').removeClass('disabled');
        $("#dryingBtnMoveToStep2b").removeClass('disabled');

        if (isOtherReceiver()) {
            $('.div-text-other-receiver-info').removeClass('hidden');
        }
    }
    var gotoReceiverForm = function () {
        if ($dryingAgreementForm.find('#Signer').val().length == 0) {
            purchasingAgreementService.getReceiversForDigitalSigning()
                .done(function (data) {
                    $.each(data,
                        function (index, item) {
                            var role = item.RoleProfileName;
                            var displayField = item.Name;
                            if (role && role.length > 0) {
                                displayField = role + ' (' + displayField + ')';
                            }

                            $dropdownReceivers.find('.dropdown').append('<li data-email="' +
                                item.Email +
                                '" data-name="' +
                                item.Name +
                                '" data-mobilePhoneNumber="' +
                                item.MobilePhoneNumber +
                                '" data-personalNumber="' +
                                item.PersonalNumber +
                                '"><a href="javascript:void(0)">' +
                                displayField +
                                '</a></li>');
                        });
                    setDropdown($dropdownReceivers, 'type-3');
                    $dropdownReceivers.parents('.agreement-element').removeClass('disabled');
                    $('.div-receiver-loader').addClass('hidden');
                });
        } else {
            $("#dryingBtnMoveToStep2b").removeClass('disabled');
            $('.div-receiver-loader').addClass('hidden');
        }
    }

    var onReview = function () {
        if (isOtherReceiver()) {
            $('#ReceiverName').val($('#ReceiverEmail').val());
        }
        $('.div-review-receiver_mobile_phone_number').addClass('hidden');
        $('.review_receiver_name').html($('#ReceiverName').val());
        $(".review_receiver_personal_number").html(maskPersonalNumber($("#ReceiverPersonalNumber").val()));

        $('.review_receiver_email').html($('#ReceiverEmail').val());
        if ($('#Mobilephone').val().length > 0) {
            $('.review_receiver_mobile_phone_number').html($('#Mobilephone').val());
            $('.div-review-receiver_mobile_phone_number').removeClass('hidden');
        }
    }

    var initEvent = function () {
        $dropdownReceivers.change(onReceiverChange);
        $('#dryingBtnMoveToStep2').click(function () {
            $('#dryingStep1').addClass('hidden');
            if (isInternal) {
                gotoReceiverForm();
                $('#dryingStep2a').removeClass('hidden');
            } else {
                $('#dryingStep2b').removeClass('hidden');
            }
        });
        $('#dryingBtnMoveToStep2b').click(function () {
            $('#dryingStep1').addClass('hidden');
            if (isInternal && $dryingAgreementForm.valid()) {
                onReview();
                $('#dryingStep2a').addClass('hidden');
                $('#dryingStep2b').removeClass('hidden');
            }
        });
        $('#dryingBtnBackToStep1').click(function () {
            $('.errorSaveDryingAgreement').addClass('hidden');
            $('#dryingStep2a').addClass('hidden');
            $('#dryingStep2b').addClass('hidden');
            $('#dryingStep1').removeClass('hidden');
        });
        $('#dryingBtnBackToStep2').click(function () {
            $('.errorSaveDryingAgreement').addClass('hidden');
            $('#dryingStep2b').addClass('hidden');
            $('#dryingStep2a').removeClass('hidden');
        });
        $('#dryingBtnMoveToStep3').click(function () {
            $("#dryingAgreementForm").submit();
        });
        $('#approveDryingAgreementTerm').change(function () {
            if ($(this).is(':checked')) {
                $('#approveDryingAgreementTermInStep2').prop('checked', true);
                $('#dryingBtnMoveToStep2,#dryingBtnMoveToStep2b, #dryingBtnMoveToStep3').removeClass('disabled');
            } else {
                $('#approveDryingAgreementTermInStep2').prop('checked', false);
                $('#dryingBtnMoveToStep2,#dryingBtnMoveToStep2b, #dryingBtnMoveToStep3').addClass('disabled');
            }
        });
        $dryingAgreementForm.submit(function (e) {
            e.preventDefault();
            $('.errorSaveDryingAgreement').addClass('hidden');
            $dryingAgreementForm.find('button').prop('disabled', true);
            $('.div-signing-loader').removeClass('hidden');


            var data = $dryingAgreementForm.serializeArray();

            // If it's internal site, we add current customer, to validate in backend
            if (isInternal) {
                var currentCustomerNumber = $('#currentCustomerNumber').attr('data-value');
                data.push({ name: 'CustomerNumber', value: currentCustomerNumber });
            }

            $.ajax({
                url: "/api/drying-agreement/save",
                method: 'post',
                data: data
            }).done(function (resp) {
                var errorInstructions = '<p>Ett fel uppstod när avtalet ' + resp.AgreementNumber + ' skulle skickas. Vänligen forsök igen senare. </p>';
                if (resp.Message && (resp.Message.indexOf("Error") >= 0 || resp.Message.indexOf("Fel") >= 0)) {

                    let internalMessage = resp.Message.indexOf("Error-customerNbrMismatch") >= 0
                        ? "Kundnumret stämmer inte med nuvarande aktiva kund, ladda om sidan!"
                        : "Vänligen kontrollera om avtalet skapats i M3.";
                    errorInstructions = isInternal
                        ? internalMessage
                        : "Vänligen kontakta LM² supporten.";
                    $('.errorSaveDryingAgreement').html(
                        '<p>Ett fel uppstod när avtalet skulle skapas. ' +
                        errorInstructions +
                        '</p>');
                    $('.errorSaveDryingAgreement').removeClass('hidden');
                } else if (!resp.SigningUrl|| resp.SigningUrl == null || resp.SigningUrl.indexOf("Error") >= 0 || resp.SigningUrl.indexOf("Fel") >= 0 || resp.SigningUrl.indexOf("http") < 0) {
                    $('.errorSaveDryingAgreement').html(errorInstructions);
                    $('.errorSaveDryingAgreement').removeClass('hidden');
                } else {
                    $('input[name="AgreementNumber"]').val(resp.AgreementNumber);
                    $('input[name="SigningUrl"]').val(resp.SigningUrl);
                    if (isInternal) {
                        if (!(resp.Recipients && resp.Recipients.Signers && resp.Recipients.Signers.length > 0)) {
                            //throw "No recipients";
                            $('.errorSaveDryingAgreement').html(errorInstructions);
                            $('.errorSaveDryingAgreement').removeClass('hidden');
                            return;
                        }
                        var receiver = resp.Recipients.Signers[0];
                        var data = {};
                        data.AgreementNumber = resp.AgreementNumber;
                        data.SigningUrl = resp.SigningUrl;
                        data.ReceiverName = receiver.Name;
                        data.ReceiverEmail = receiver.Email;
                        data.ReceiverPersonalNumber = receiver.PersonalNumber;
                        data.ReceiverMobilePhoneNumber = receiver.MobilePhoneNumber;
                        data.Message = resp.Message;
                        $dryingAgreementForm.find('button').prop("disabled", true).addClass('disabled');
                        purchasingAgreementService.sendForDigitalSigning(data)
                            .done(function (resp) {
                                if (resp !== "OK") {
                                    $('.errorSaveDryingAgreement').html(errorInstructions);
                                    return;
                                }
                                $('#dryingStep2a').addClass('hidden');
                                $('#dryingStep2b').addClass('hidden');
                                $('#dryingStepConfirmation').removeClass('hidden');
                            })
                            .always(function () {
                                setTimeout(function () {
                                    $dryingAgreementForm.find('button').prop("disabled", false).removeClass('disabled');
                                }, 250);
                            });

                    }
                    else {
                        setTimeout(function () {
                            window.open(resp.SigningUrl, "_blank");
                            $('#DigitalSigningLink').attr("href", resp.SigningUrl);
                            setTimeout(function () {
                                $('#dryingStep2a').addClass('hidden');
                                $('#dryingStep2b').addClass('hidden');
                                $('#dryingStepConfirmation').removeClass('hidden');
                            }, 500);
                        }, 500);

                    }
                }

            }).always(function () {
                    setTimeout(function () {
                        $dryingAgreementForm.find('button').prop("disabled", false).removeClass('disabled');
                        $('.div-signing-loader').addClass('hidden');
                    }, 250);
                });
        });
    };
    function setupValidation() {
        if ($().validate) {
            $dryingAgreementForm.validate({
                ignore: [],
                errorElementClass: 'error',
                errorClass: 'error-item',
                errorElement: 'span',
                onkeyup: false,
                rules: {
                    ReceiverEmail: {
                        required: function () {
                            return !$('#dryingStep2a').hasClass('hidden');
                        },
                        validateReceiverEmail: true
                    },
                    ReceiverPersonalNumber: {
                        required: function () {
                            return !$('#dryingStep2a').hasClass('hidden');
                        },
                        validateReceiverPersonalNumber: true
                    },
                    ReceiverMobilePhoneNumber: {
                        required: false,
                        validateReceiverMobilePhoneNumber: true
                    }
                },
                messages: {
                    ReceiverEmail: {
                        required: window.validationMessage.email.required,
                        validateReceiverEmail: window.validationMessage.email.valid
                    },
                    ReceiverPersonalNumber: {
                        required: window.validationMessage.personNumber.required,
                        validateReceiverPersonalNumber: window.validationMessage.personNumber.purchasingagreementssnvalid
                    },
                    ReceiverMobilePhoneNumber: {
                        required: window.validationMessage.mobileSE.required,
                        validateReceiverMobilePhoneNumber: window.validationMessage.mobileSE.valid
                    }
                },
                highlight: function (element, errorClass, validClass) {
                    $('li#p_' + $(element).attr('name')).show();
                    var errors = $('ul.errors-list li').filter(function () { return $(this).css('display') === 'list-item'; }).length;
                    if (errors >= 3) {
                        $('ul.errors-list').show();
                    }
                    $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
                    $('li#p_' + $(element).attr('name')).hide();
                    var errors = $('ul.errors-list li').filter(function () { return $(this).css('display') === 'list-item'; }).length;
                    if ($('ul.errors-list').find('li[id^="p"]').is(":visible") === false || errors < 3) {
                        $('ul.errors-list').hide();
                    }
                },
                errorPlacement: function (error, element) {
                    var typeElement = $(element).attr('type');
                    if (typeElement === 'radio') {
                        element.parent('div.lm__radio').parent().before(error);
                    } else {
                        element.after(error);
                    }
                }
            });
        }
    }

    $(function createValidationRulesForDryingAgreements() {
        if ($.validator) {
            $.validator.addMethod("validateReceiverEmail",
                function (email, element) {
                    return this.optional(element) ||
                        $(element).parents('.agreement-element').hasClass('disabled') ||
                        window.validation.email(email);
                },
                window["validationMessage"].email.valid);
            $.validator.addMethod("validateReceiverPersonalNumber",
                function (personNumber, element) {
                    return this.optional(element) ||
                        $(element).parents('.agreement-element').hasClass('disabled') ||
                        window.validation.personNumber(personNumber);
                },
                window["validationMessage"].email.valid);
            $.validator.addMethod("validateReceiverMobilePhoneNumber",
                function (receiverMobilePhoneNumber, element) {
                    return this.optional(element) ||
                        $(element).parents('.agreement-element').hasClass('disabled') ||
                        receiverMobilePhoneNumber.length == 0 ||
                        window.validation.mobileSE(receiverMobilePhoneNumber);
                },
                window.validationMessage.mobileSE.valid);
        }
    });
    var init = function () {
        if ($dryingAgreementForm.length > 0) {
            initEvent();
            setupValidation();
        }
    };

    return {
        init: init
    };
})();